import React, { useState, useEffect } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { DataGrid } from "@mui/x-data-grid";
import { IconButton } from "@mui/material";
import VisibilityIcon from "@material-ui/icons/Visibility";
import moment from "moment-timezone";
import Pagination from "../Pagination/Pagination";
import { useAssignedForms } from '../../hooks/useAssignedForms';
import { useNavigate } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
	container: {
		backgroundColor: "#fff",
		padding: "14px 16px",
		height: "100%",
		flex: 1,
		display: "flex",
		flexDirection: "column",
		justifyContent: "space-between",
	},
	actionText: {
		fontSize: "14px",
		marginLeft: "4px",
		color: "#006ac6",
	},
}));

export default function AssignedView({ setLoading }) {
	const classes = useStyles();
	const [currentPage, setCurrentPage] = useState(1);
	const [templatesPerPage] = useState(10);
	const { assignedForms, getAssignedForms } = useAssignedForms();
	const navigate = useNavigate();
	const handlePageChange = (newPage) => {
		setCurrentPage(newPage);
	};

	const toComplete = (row) => {
		console.log(row);
		setLoading(true, "Loading...");
		navigate(`/docFormFiller/${row.templateId}/${row.id}`);
	}

	const columns = [
		{
			field: "templateName",
			headerName: "Document Name",
			flex: 1.5,
		},
		{
			field: "requestedAt",
			headerName: "Request Date",
			flex: 1,
		},
		{
			field: "completed",
			headerName: "Completed",
			flex: 0.8,
			valueGetter: (params) => {
				return params.row.completed === 0 ? "Incomplete" : "Complete";
			},
		},
		{
			field: "toComplete",
			headerName: "Actions",
			flex: 0.8,
			renderCell: (params) => {
				return (
					<div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
						<IconButton color="primary" title="To Complete" onClick={() => toComplete(params.row)}>
							<VisibilityIcon color="primary" />
							<span className={classes.actionText}>To Complete</span>
						</IconButton>
					</div>
				);
			},
		},
	];

	// Calculate pagination
	const indexOfLastForm = currentPage * templatesPerPage;
	const indexOfFirstForm = indexOfLastForm - templatesPerPage;
	const currentForms = assignedForms.slice(indexOfFirstForm, indexOfLastForm);

	return (
		<div className={classes.container}>
			<DataGrid
				rows={assignedForms}
				columns={columns}
				pageSize={10}
				rowsPerPageOptions={[10]}
				disableSelectionOnClick
				autoHeight
				sx={{
					"& .MuiDataGrid-columnHeaders": {
						backgroundColor: "#006ac6",
						color: "white",
						borderBottom: "none !important",
					},
					"& .MuiDataGrid-row": {
						backgroundColor: "#fff !important",
						"&:nth-of-type(even)": {
							backgroundColor: "#f5f5f5 !important",
						},
					},
					"& .MuiDataGrid-cell": {
						padding: "8px !important",
						fontSize: "14px",
					},
					border: "none",
					"& .MuiDataGrid-cell": {
						border: "none",
					},
					"& .MuiDataGrid-columnHeader": {
						borderRight: "none",
					},
				}}
			/>
		</div>
	);
}